import React from "react";
import Hero from "../components/ModernTravelsHero"
import FeaturesSection from "../components/FeaturesSection";
import TravelLandingPage from "../components/TravelLandingPage";
import RoutesUI from "../components/RoutesUI";
import ShreepujaTravelsLanding from "../components/ShreepujaTravelsLanding"
import TravelBookingHero from "../components/TravelBookingHero";
import TravelComfortUI from "../components/TravelComfortUI"
import GreatServiceUI from "../components/GreatServiceUI"
import HyderabadRoutes from "../components/HyderabadRoutes"
import ShreePujaTravelsTestimonials from "../components/ShreePujaTravelsTestimonials"
const HomePage = () => {
    return (
        <div>
            <Hero />
            <FeaturesSection />
             <GreatServiceUI />
             <HyderabadRoutes />
            <TravelLandingPage />
            <RoutesUI />
            <ShreepujaTravelsLanding />
            <TravelBookingHero />
            <TravelComfortUI />
            <ShreePujaTravelsTestimonials />
        </div>
    );
}

export default HomePage;